'use strict';

var chat = require('./client');

module.exports = chat;